module.exports = __webpack_public_path__ + "images/f942d7cfc3e06cadc869f19271de245d-Roboto-ThinItalic.svg";